import Loader from "react-loader-spinner";
import { Fragment, useRef, useState } from "react";
import { Button, Col, FormControl } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setDialog } from "../../store/api/Modals";
import { useForm } from "react-hook-form";
import { addNewEvent, deleteEvent, getCustomerEvents } from "../../store/api/CustomerApi";
import { Check2Square, CheckLg, DashCircleFill, List, ListTask, PlusSquare, Search } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import ModalSelectUser from "../../../Components/Modals/ModalSelectUser";
import BihamtaTable from "../../../Components/BihamtaTable";
import TreeView from "../../../Components/TreeView/TreeView";
import ModalSelectCategory from "./ModalSelectCategory";
import ModalCreateEditWorkItems from "../../../Projects/pages/ModalCreateEditWorkItems";
import { icon } from "@fortawesome/fontawesome-svg-core";
const CustomerEvents = (props) => {


    const dateTo = useRef();
    const dateFrom = useRef();
    const currPage = useRef(1);
    const eventData = useRef({});
    const dispatch = useDispatch();
    const { register, handleSubmit } = useForm();
    const { customerID, isPreCustomer } = props;
    const [pending, setPending] = useState(false);
    const [selectedUser, selectUser] = useState(null);
    const [eventError, setEventError] = useState({});
    const [modalUsers, setModalUsers] = useState({ show: false });
    const searchData = useRef({ Take: 10, Skip: 0, CustomerID: customerID, IsStaff: false, IsPreCustomer: isPreCustomer ?? false });
    const [showAddEvent, setShowAddEvent] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedCatForSearch, setSelectedCatforSearch] = useState(null);
    const [modalCategories, setModalCategories] = useState({ show: false });
    const [modalWorkItemData, setModalWorkItemData] = useState({ show: false });
    const { typeList } = useSelector(state => {
        return {
            typeList: state.customerDataReducer.eventTypeList
        }
    });
    const search = (data) => {
        if (selectedUser && selectedUser.ID) {
            searchData.current.CreateById = selectedUser.ID;
        }
        if (dateFrom.current.input.value === "") {
            searchData.current.DateFrom = null;
        }
        if (dateTo.current.input.value === "") {
            searchData.current.DateTo = null;
        }
        searchData.current.Skip = currPage.current - 1;
        searchData.current.CustomerID = customerID;
        searchData.current.IsPreCustomer = isPreCustomer ?? false;
        searchData.current.IsStaff = false;
        searchData.current.Take = 10;
        Object.assign(searchData.current, data);
        dispatch(getCustomerEvents(searchData.current));
    }
    const addEvent = () => {
        let er = {};
        if (!eventData.current.Description || eventData.current.Description === '') {
            er.Description = 'N';
        }
        if (!eventData.current.EventTypeID || eventData.current.EventTypeID === "") {
            er.EventTypeID = 'N';
        }
        setEventError(er);
        if (er.EventTypeID || er.Description) {
            return;
        }
        setPending(true);
        eventData.current.CustomerID = customerID;
        eventData.current.IsPreCustomer = isPreCustomer ?? false;
        eventData.current.CategoryID = selectedCategory?.id;
        const onSuccess = () => {
            setPending(false);
            let searchData = {};
            searchData.Skip = 0;
            searchData.CustomerID = customerID;
            searchData.IsPreCustomer = isPreCustomer ?? false;
            searchData.IsStaff = false;
            searchData.Take = 10;
            eventData.current = {};
            setShowAddEvent(false);
            setSelectedCategory(null);
            dispatch(getCustomerEvents(searchData));
        }
        dispatch(addNewEvent(eventData.current, onSuccess));
    }
    const cancelEvent = () => {
        eventData.current = {};
        setEventError({});
        setShowAddEvent(false);
    }
    const showUserPOP = () => {
        setModalUsers({ show: true, selectUserWithName: selectUser });
    }
    function gotoEventAttachment(row) {
        if (row.Description.includes("حذف")) {
            return;
        }
        if (row.AttachmentType === "Sale" ||
            row.AttachmentType === "PreSale" ||
            row.AttachmentType === "Purchase" ||
            row.AttachmentType === "PrePurchase" || row.AttachmentType?.includes("Formal")) {
            const isFormal = row.AttachmentType.includes("Formal");
            window.open(`/Sale/Invoice/${row.AttachmentType.replace("Formal", "")}/${row.AttachmentID}/${isFormal}`)
        }
        else if (row.AttachmentType === "repair" || row.AttachmentType === "install") {
            window.open(`/Services/Service/${row.AttachmentID}/${row.AttachmentType}`);
        }
    }
    const showModalWorkItemData = (row) => {
        setModalWorkItemData({
            show: true,
            title: row.Description,
            entityType: "Event",
            entityId: row.ID
        })
    }
    const tableColes = [
        { colTitle: "تاریخ رویداد", colName: "PCreationDate", showInMobile: true },
        { colTitle: "شرح رویداد", colName: "Description", showInMobile: true, maxTextLength: 150, colType: "string", hasTooltip: true },
        { colTitle: "نوع رویداد", colName: "EventTypeStr" },
        { colTitle: "دسته بندی", colName: "CategoryCode+CategoryName", colType: "string" },
        { colTitle: "تاریخ پیگیری", colName: "pNextDate" },
        { colTitle: "ثبت کننده", colName: "CreateByName" },
        // { colTitle: "جزئیات بیشتر", colName: "MoreDetails", showInMobile: false }

    ]
    const tableRowButtons = [
        {
            title: "حذف رویداد", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف رویداد',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteEvent(item.ID, search)
                }))
            }
        },
        { title: "تبدیل به وظیفه", type: "common",tooltip:"تبدیل به وظیفه", icon: <Check2Square className="rowBtn" color="green"/>, onclick: showModalWorkItemData }

    ]
    const showModalCategory = () => {
        setModalCategories({
            show: true,
            setSelectedCategory: setSelectedCategory
        })
    }
    const showModalCategoryForSearch = () => {
        setModalCategories({
            show: true,
            setSelectedCategory: setSelectedCatforSearch
        })
    }
    return (
        <Fragment>
            <ModalSelectUser popData={modalUsers} setUserPop={setModalUsers} />
            <ModalCreateEditWorkItems modalData={modalWorkItemData} setModalData={setModalWorkItemData} />
            <ModalSelectCategory modalData={modalCategories} setModalData={setModalCategories} />
            {!showAddEvent &&
                <div style={{ border: "1px solid #b1b1b1", borderRadius: "3px", padding: "5px", paddingBottom: "15px", margin: "5px" }}>
                    <form onSubmit={handleSubmit(search)}>
                        <div className="row" >
                            <div className="col-md-2 form-group">
                                <label>نوع رویداد</label>
                                <select className="search-input" name="EventTypeID" ref={register({})}>
                                    <option value="">انتخاب کنید</option>
                                    {typeList && Array.isArray(typeList) &&
                                        typeList.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                                </select>
                            </div>
                            <div className="col-md-2 form-group">
                                <label>دسته بندی رویداد</label>
                                <input type="hidden" readOnly value={selectedCatForSearch?.id ?? ""} name="CategoryID" ref={register({})} />
                                <input className="search-input" readOnly value={selectedCatForSearch?.name ?? ""} />
                                <Button className="btn-input-tiny" onClick={showModalCategoryForSearch} style={{ top: 22 }}><List size={17} /></Button>
                            </div>
                            <div className="col-md-1 form-group">
                                <label>از تاریخ</label>
                                <DatePicker ref={dateFrom} isGregorian={false} timePicker={false} className="search-input"
                                    onChange={value => { searchData.current.DateFrom = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="col-md-1 form-group">
                                <label>تا تاریخ</label>
                                <DatePicker ref={dateTo} isGregorian={false} timePicker={false} className="search-input"
                                    onChange={value => { searchData.current.DateTo = value.local("en").format("YYYY/MM/DD") }} />
                            </div>
                            <div className="col-md-2 form-group">
                                <label style={{ display: "block" }}>شرح رویداد</label>
                                <input type="text" className="search-input" name="Description" ref={register({})} />
                            </div>
                            {/* <div className="col-md-2 form-group">
                                <label style={{ display: "block" }}>جزئیات بیشتر</label>
                                <input type="text" className="form-control" name="MoreDetails" ref={register({})} />
                            </div> */}
                            <div className="col-md-2 form-group">
                                <label style={{ display: "block" }}>ثبت کننده</label>
                                <input type="text" className="search-input" readOnly value={selectedUser ? selectedUser.Name : ""} />
                                <Button className="btn-input-tiny" onClick={showUserPOP} style={{ top: 22 }}><List size={17} /></Button>
                            </div>
                            <Col md={2} style={{ display: "flex", alignItems: "flex-end", paddingBottom: "2px" }}>
                                <Button type="submit" variant="secondary" className="group-Btn-large"><Search />&nbsp;جستجوی رویداد</Button>
                            </Col>
                        </div>
                    </form>

                </div>
            }
            {showAddEvent &&
                <div style={{ border: "1px solid #b1b1b1", borderRadius: "3px", padding: "5px" }}>
                    <div className="row">
                        <div className="col-md-2 form-group">
                            <label>نوع رویداد</label><span style={{ color: "red", fontSize: "14px" }}>*</span>
                            <select className="form-control" onChange={e => eventData.current.EventTypeID = e.target.value}>
                                <option value="">انتخاب کنید</option>
                                {typeList && Array.isArray(typeList) &&
                                    typeList.map((item, i) => <option key={i} value={item.ID}>{item.InfoName}</option>)}
                            </select>
                            {eventError.EventTypeID && <small className="errors">نوع رویداد الزامی است</small>}
                        </div>
                        <div className="col-md-2 form-group">
                            <label>دسته بندی رویداد</label>
                            <FormControl readOnly value={selectedCategory?.name ?? ""} />
                            <Button className="btn-input-tiny" onClick={showModalCategory}><List size={23} /></Button>
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ پیگیری</label>
                            <DatePicker name="AlarmDate" isGregorian={false} timePicker={false} className="form-control"
                                onChange={value => { eventData.current.NextDate = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>شرح رویداد</label><span style={{ color: "red", fontSize: "14px" }}>*</span>
                            <input className="form-control" onChange={e => eventData.current.Description = e.target.value} />
                            {eventError.Description && <small className="errors">شرح رویداد الزامی است</small>}
                        </div>

                    </div>
                    <Button variant="success" className="group-Btn mt-2" onClick={addEvent}>
                        {!pending && <Fragment><CheckLg />&nbsp;ثبت رویداد</Fragment>}
                        {pending && <Fragment> <Loader type="BallTriangle" color="white" height={15} width={15} style={{ display: "inline-block" }} />&nbsp; منتظر بمانید</Fragment>}
                    </Button>
                    <Button variant="danger" className="group-Btn mt-2" onClick={cancelEvent}><DashCircleFill size={16} />&nbsp;انصراف</Button>
                </div>
            }
            {!showAddEvent && <Button className="group-Btn-smalll" style={{ textAlign: "center" }} onClick={() => setShowAddEvent(true)}><PlusSquare size={18} /></Button>}
            <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} reducerName="customerDataReducer" objectName="customerEventList" hasPaging={true}
                rowClick={gotoEventAttachment} filterData={searchData.current} searchMethod={(data) => dispatch(getCustomerEvents(data))} />

        </Fragment >
    )
}
export default CustomerEvents;